"use client"

import { NuqsAdapter } from "nuqs/adapters/next/app"
import { StripeProvider } from "@/context/StripeContext"
import { TopProgressBar } from "@/components/shared/TopProgressBar"
import { TooltipProvider } from "@/components/ui/tooltip"
import { PostHogProvider } from "@/context/PostHogProvider"
import { AppStoreProvider } from "@/stores/AppStoreProvider"
import type { AppState } from "@/stores/appStore"
import React from "react"
import NextAdapterApp from "next-query-params/app"
import { QueryParamProvider } from "use-query-params"

export const ContextProviders = ({ children, appState }: { children: React.ReactNode; appState: AppState }) => {
  return (
    <PostHogProvider>
      <NuqsAdapter>
        <TooltipProvider>
          <StripeProvider>
            <QueryParamProvider adapter={NextAdapterApp}>
              <AppStoreProvider initState={appState}>
                <TopProgressBar />
                {children}
              </AppStoreProvider>
            </QueryParamProvider>
          </StripeProvider>
        </TooltipProvider>
      </NuqsAdapter>
    </PostHogProvider>
  )
}
